<template lang="html">

  <section class="login">
    <div class="pageHeading">
      <h1>Verify Email</h1>
    </div>

    <div v-show="$route.query.token === undefined">
      <div v-show="waitingOnServer || emailSent">
        <span v-if="!emailSent">Sending Email...</span>
        <v-progress-linear v-if="!emailSent" :indeterminate="true"></v-progress-linear>

      </div>
      <div v-show="!waitingOnServer">
        <p>We emailed you a link to verify this account's email address. After your email is confirmed you will be able to sign in</p>
        <small>Please check your spam folder if you have not received the email</small>
        <br/>
        <v-btn v-if="!emailSent" @click="recover" small color="primary" >Resend Link</v-btn>
      </div>

    </div>

    <div v-show="successful == true">
      <p>Thank you for verifying your email. Redirecting to login...</p>
    </div>

    <div style="color: red" v-show="successful == false">
      <p>{{error}}</p>
    </div>



  </section>

</template>

<script lang="js">
  export default  {
    name: 'verify',
    props: [],
    mounted() {
      this.$busyDialog = false
        if(this.$route.query.token != undefined) {
            this.verifyFromURL()
        } else {
          this.userEmail = this.$feathers.get('user').email
          this.$feathers.logout()
        }
    },
    data() {
      return {
          error: '',
          successful: null,
        waitingOnServer: false,
        emailSent: false,
        userEmail: ''


      }
    },
    methods: {
        recover() {
            this.waitingOnServer = true;
            var vueThis = this;
            this.$services.authmanagement.create({
              "action": "sendResetPwd",
              "value": { "email": vueThis.userEmail}

            }).then((result) => {
              console.log(result)
              vueThis.emailSent = true

            }).catch(function(error){
              vueThis.successful = false;
              vueThis.error = error.message
            }).finally(function(){

              vueThis.waitingOnServer = false;
            })
        },
        verifyFromURL() {
            console.log('token is', this.$route.query.token)
            var vueThis = this;
            this.$services.authmanagement.create({
                "action": "verifySignupLong",
                "value":  this.$route.query.token,

            }).then((result) => {
                console.log(result)
                vueThis.successful = true;
                setTimeout(()=>{
                    vueThis.$router.push('/')
                }, 3000)

            }).catch(function(error){
                vueThis.successful = false;
                vueThis.error = error.message
            })
                .finally(() => {

                })
        }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .verify {

  }
</style>
